// @module Ames.HomeStore.HomeStore
define("CustomMerchantZone.Confirmation.View", [
  "custommerchantzone_confirmation.tpl",

  "Backbone",
], function (
  custommerchantzone_confirmation_tpl,

  Backbone
) {
  "use strict";

  // @class Ames.HomeStore.HomeStore.View @extends Backbone.View
  return Backbone.View.extend({
    template: custommerchantzone_confirmation_tpl,

    initialize: function (options) {
      setTimeout(function () {
        // add class to modal modal-dialog global-views-modal
        // to make it full screen
        $(".global-views-modal").addClass("global-views-modal-large");
      }, 500);
      this.item = options.item || {
        name: "",
        internalid: "",
        thumbnail: "https://www.all-wall.com/scs/img/no_image_available.jpg",
        priceformatted: "",
        url: "",
        id: "",
        price: "",
        quantity: 1,
      };
    },

    events: {},

    bindings: {},

    childViews: {},

    //@method getContext @return Ames.HomeStore.HomeStore.View.Context
    getContext: function getContext() {
      return {
        name: this.item.name || "",
        internalid: this.item.internalid || "",
        thumbnail: this.item.thumbnail,
        priceformatted: this.item.priceformatted || "",
        url: this.item.url || "",
        id: this.item.id || "",
        quantity: this.item.quantity || 1,
        price: this.item.price || "",
      };
    },
  });
});
